export default "__VITE_ASSET__C2E9f3aB__"